module.exports = __webpack_public_path__ + "static/assets/36ca8833e2808c7aec0535e41b8c09cf.svg";